import { EntityType } from 'api'
import { createAllEntitiesHook, createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useHaircut = createEntityHook(EntityType.HAIRCUT_ENTRY)
export const useAllHaircuts = createAllEntitiesHook(EntityType.HAIRCUT_ENTRY)
export const useHaircutGetter = createEntityGetterHook(EntityType.HAIRCUT_ENTRY)
export const useHaircutReferenceData = createReferenceDataEntityHook(EntityType.HAIRCUT_ENTRY)
